import { u as updateLocalStore, b as defaultQuote, s as state, c as defaultStoreState, A as AppState } from './index-4d2624c8.js';
import { k as getInputValues, m as mergeVehicle, n as isPlainObject, l as logger } from './logger-faaf508a.js';
import { q as quoteService } from './quoteService-727472be.js';
import { A as APP_VERSION } from './index-854fa3af.js';

function getCleanQuoteState(storeId) {
  updateLocalStore(storeId, {
    quoteState: defaultQuote,
  });
}
function getQuotePending(storeId) {
  updateLocalStore(storeId, { appStatus: AppState.FCIS_LOADING });
}
function getQuoteSuccess(storeId, payload) {
  const newState = {
    appStatus: AppState.FCIS_LOAD_SUCCESS,
    quoteState: Object.assign(Object.assign({}, payload), { error: null }),
    payloadState: Object.assign(Object.assign({}, state.instances[storeId].payloadState), { opaque: payload.quoteResponse.opaque, vehicle: Object.assign(Object.assign({}, state.instances[storeId].payloadState.vehicle), { financialCode: payload.quoteResponse.output.financialCode }) }),
  };
  updateLocalStore(storeId, newState);
}
function getQuoteError(storeId, errorObj) {
  const newState = {
    quoteState: Object.assign(Object.assign({}, state.instances[storeId].quoteState), { error: Object.assign({}, errorObj) }),
  };
  updateLocalStore(storeId, newState);
}
function setErrorState(storeId, error) {
  let errorObj;
  if (error instanceof Error) {
    errorObj = {
      message: error.message,
      code: error.name,
    };
  }
  else if (isPlainObject(error)) {
    errorObj = error;
  }
  else if (typeof error === 'string') {
    errorObj = {
      message: error,
    };
  }
  getQuoteError(storeId, errorObj);
}
async function getQuote(storeId, quoteService$1 = quoteService, payload) {
  getQuotePending(storeId);
  try {
    const response = await quoteService$1.getQuote(storeId, payload);
    getQuoteSuccess(storeId, response);
  }
  catch (e) {
    setErrorState(storeId, e);
  }
}
function setLinks(storeId, payload) {
  const newState = Object.assign(Object.assign({}, state.instances[storeId]), { quoteState: Object.assign(Object.assign({}, state.instances[storeId].quoteState), { links: payload }) });
  updateLocalStore(storeId, newState);
}
function setInputValues(storeId, inputs) {
  const newPayloadState = {
    payloadState: Object.assign(Object.assign({}, state.instances[storeId].payloadState), { input: getInputValues(inputs) }),
  };
  updateLocalStore(storeId, newPayloadState);
}
function setMQ(storeId, width) {
  let mq = 'MQ1';
  if (width >= 1440) {
    mq = 'MQ6';
  }
  else if (width >= 1280) {
    mq = 'MQ5';
  }
  else if (width >= 1024) {
    mq = 'MQ4';
  }
  else if (width >= 768) {
    mq = 'MQ3';
  }
  else if (width >= 480) {
    mq = 'MQ2';
  }
  updateLocalStore(storeId, { currentMQ: mq });
}
function newVehicle(storeId, payload) {
  // makes deep clone of payload to avoid side effects
  // as this is a JSON object after all, there is no need
  // to use a function for that
  const newVehicle = payload ? JSON.parse(JSON.stringify(payload)) : payload;
  const newState = {
    payloadState: Object.assign(Object.assign({}, state.instances[storeId].payloadState), { vehicle: newVehicle }),
  };
  updateLocalStore(storeId, newState);
}
function updateVehicle(storeId, payload) {
  const localStore = state.instances[storeId];
  const newState = {
    payloadState: Object.assign(Object.assign({}, localStore.payloadState), { vehicle: mergeVehicle(localStore.payloadState.vehicle, payload) }),
  };
  updateLocalStore(storeId, newState);
}
function newCustomer(storeId, payload) {
  // makes deep clone of payload to avoid side effects
  // as this is a JSON object after all, there is no need
  // to use a function for that
  const newCustomer = payload ? JSON.parse(JSON.stringify(payload)) : payload;
  const localStore = state.instances[storeId];
  const newState = {
    payloadState: Object.assign(Object.assign({}, localStore.payloadState), { customer: newCustomer }),
  };
  updateLocalStore(storeId, newState);
}
function setContext(storeId, payload) {
  const newState = {
    payloadState: payload,
  };
  updateLocalStore(storeId, newState);
}
function addInstanceToStore(id) {
  state.instances = Object.assign(Object.assign({}, state.instances), { [id]: defaultStoreState });
}

const EVENT_ID = 'click';
const DATALAYER_ID = 'dataLayer_ow';
const ACTION_ID = 'finance_calculator';
class TrackingService {
  constructor() {
    this._isTrackingEnabled = true;
    this._parentApplicationId = '';
    // The version is injected automatically on build.
    this._version = APP_VERSION;
  }
  set isTrackingEnabled(value) {
    this._isTrackingEnabled = value;
  }
  get isTrackingEnabled() {
    return this._isTrackingEnabled;
  }
  set parentApplicationId(value) {
    this._parentApplicationId = value;
  }
  initialize() {
    if (this.isTrackingEnabled) {
      logger.log('tracker initialised')();
      this.publish({
        category: 'impression',
        label: 'success',
      });
    }
  }
  update(name) {
    if (this.isTrackingEnabled) {
      logger.log('tracker update', name)();
      this.publish({ category: 'feature', label: `calculation_${name}` });
    }
  }
  error(ocapiErrorCode, vehicleName) {
    if (this.isTrackingEnabled) {
      logger.log('tracker error', ocapiErrorCode)();
      this.publish({
        category: 'feature',
        label: `error_${vehicleName}`,
        errorType: `${ocapiErrorCode}:calculationException`,
      });
    }
  }
  action(name) {
    if (this.isTrackingEnabled) {
      logger.log('tracker action', name)();
      this.publish({ category: 'link', label: name });
    }
  }
  publish(payload) {
    const trackingData = {
      event: EVENT_ID,
      eventDetail: Object.assign({ action: ACTION_ID }, payload),
      application: {
        id: 'fcis-widget',
        parentApplicationId: this._parentApplicationId,
        version: this._version,
      },
    };
    try {
      const mainWindowObject = window.top;
      const dataLayer = mainWindowObject[DATALAYER_ID];
      if (dataLayer) {
        dataLayer.push(trackingData);
        logger.log('Tracking data published', trackingData)();
      }
    }
    catch (error) {
      logger.info(`Something happened while trying to push the event: ${error}`)();
    }
  }
}
const tracker = new TrackingService();

export { getQuote as a, setErrorState as b, newCustomer as c, setLinks as d, addInstanceToStore as e, setMQ as f, getCleanQuoteState as g, setInputValues as h, newVehicle as n, setContext as s, tracker as t, updateVehicle as u };
